module.exports = __webpack_public_path__ + "static/media/8787.296ac31f.png";